import CalendarService from '../lib/services/CalendarService';
import { injectLogos } from '../lib/utils';

const fetchRetail = (params = {}, injectTickersLogos = true, pageSize = 1000): Promise<any> => {
  const query = {
    ...params,
    pagesize: pageSize,
  };

  const Calendar = new CalendarService();

  return Calendar.getRetail(query).then(({ data }: any) => {
    const items: any = [];
    if (Array.isArray(data.retail) && data.retail.length) {
      return injectTickersLogos ? injectLogos(data.retail) : data.retail;
    }
    return items;
  });
};

export { fetchRetail };
